import React, { useContext, useEffect } from 'react';
import ChatService from '../routes/teamWork/ChatPage/Base/ChatService';
import { useDispatch, useSelector } from 'react-redux';

import AuthContext from '../contexts/AuthContext';
import {
  onNotifyNewMessage,
  onGetUserRoomsWithNewMessage,
  onGetUserRoomsDetailWithNewMessage,
  onSelectRoom,
} from '../appRedux/actions';
import { useLocation } from 'react-router-dom';
import { ShowWarning } from '../helper/Alert';

export default function ChatContext(props: any) {
  const location = useLocation();
  const authContext = useContext(AuthContext);
  const userEp = authContext.userEmployeePosition;

  const dispatch = useDispatch();
  const fgChat = useSelector(({ fgChat }: any) => fgChat);

  const chatService = new ChatService(
    notifyNewMessageCallback,
    userConnetionStatusCallback,
    disconnectedCallback,
  );

  async function disconnectedCallback() {
    await chatService.startConnection();
  }

  function notifyNewMessageCallback(data: any) {
    dispatch(onNotifyNewMessage(data));
  }

  function userConnetionStatusCallback(data: any) {
    console.log('userConnetionStatusCallback', data);
  }

  // Start SignalR
  useEffect(() => {
    async function startSignalRConnection() {
      (await chatService.startConnection()) as boolean;
      console.log('Connected');
    }

    if (
      !fgChat.signalRIsDisconnected &&
      window.config.signalRurl &&
      userEp.personCode
    ) {
      startSignalRConnection();
    }
  }, [userEp]);

  useEffect(() => {
    if (
      fgChat.signalRIsDisconnected &&
      window.config.signalRurl &&
      userEp.personCode &&
      !fgChat.sendRequestForGetNewMessage
    ) {
      dispatch(onGetUserRoomsWithNewMessage());
    }
  }, [fgChat.signalRIsDisconnected]);

  useEffect(() => {
    const ids = fgChat.userRoomsDetailWithNewMessage.map(
      (item: any) => item.Id,
    );
    fgChat.userRoomsWithNewMessage.map((roomId: any) => {
      if (!ids.includes(roomId))
        return dispatch(onGetUserRoomsDetailWithNewMessage(roomId));
    });
  }, [fgChat.userRoomsWithNewMessage.length]);

  // Cleanup Data
  useEffect(() => {
    if (location.pathname !== '/team-work/chat' && fgChat.selectedRoom) {
      dispatch(onSelectRoom(null));
    }
  }, [location]);

  return <>{props.children}</>;
}
